export default "/_next/static/chunks/fonts/MinionProSemiboldIt-c4feffc5a60c5188012ffd2ff3705067.woff";